import { useAuthStore } from '@/store/auth'
import { useOrganizationStore } from '@/store/organization'
import { useAuth, useOrganizationList } from '@clerk/clerk-react'
import { useEffect } from 'react'

export const ClerkAuthLoader = () => {
  const { isLoaded, isSignedIn, signOut, getToken, orgId } = useAuth()
  const { setActive } = useOrganizationList()
  const setAuthState = useAuthStore((s) => s.setAuthState)
  const setOrganizationState = useOrganizationStore(
    (s) => s.setOrganizationState,
  )

  console.log('isLoaded', isLoaded)
  console.log('isSignedIn', isSignedIn)

  useEffect(() => {
    setAuthState({
      isLoadingExternalAuth: !isLoaded,
      hasExternalAuth: !!isSignedIn,
      accessTokenGetter: getToken,
      signOut,
    })
  }, [setAuthState, isLoaded, isSignedIn, signOut, getToken])

  useEffect(() => {
    if (setActive) {
      setOrganizationState({
        setActiveExternalOrganization: (orgId) =>
          setActive({ organization: orgId }),
      })
    }
  }, [setActive, setOrganizationState])

  useEffect(() => {
    setOrganizationState({
      externalOrganizationId: orgId ?? undefined,
    })
  }, [orgId, setOrganizationState])

  return null
}
